import "./App.css";
import logo from "./logo.png";
import Header from "./components/Header";
import Router from "./router/router";
function App() {
  return (
    <>
    <Header/>
    <Router/>
    </>
  );
}

export default App;
